<template>
  <vs-row>
    <vs-col vs-w="3" class="mt-4">
      Mostrando <select v-model="elementosPorPagina" v-on:change="handleChangeItemPerPage()">
        <option value="10">10</option>
        <option value="20">20</option>
        <option value="30">30</option>
        <option value="40">40</option>
        <option value="50">50</option>
      </select> elementos
    </vs-col>
    <vs-col vs-w="9" class="mt-4">
      <fb-paginacion
        :total="pages"
        :max="maxPages"
        v-model="actualPage"
        v-on:change="pageChange"
      />
    </vs-col>
  </vs-row>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import FbPaginacion from '@/febos/chile/_vue/componentes/FbPaginacion';

export default {
  props: {
    value: { type: Number, required: false, default: 1 },
    maxPages: { type: Number, required: false, default: 10 },
  },
  components: { FbPaginacion },
  data() {
    return {
      actualPage: this.value,
      elementosPorPagina: 10
    };
  },
  computed: {
    ...mapGetters('Emails', ['loading', 'pages', 'page'])
  },
  watch: {
    value(newValue) {
      this.actualPage = newValue;
    },
    actualPage(newValue) {
      this.$emit('input', newValue);
    },
    page(newValue) {
      this.actualPage = newValue;
    }
  },
  methods: {
    ...mapActions('Emails', ['getEmailsList', 'movePage', 'changeItemPerPage']),
    pageChange(value) {
      this.movePage(value);
    },
    handleChangeItemPerPage() {
      this.changeItemPerPage(this.elementosPorPagina);
    }
  }
};

</script>
